import { render, staticRenderFns } from "./widget-task.vue?vue&type=template&id=b9d4e058&scoped=true"
import script from "./widget-task.vue?vue&type=script&lang=js"
export * from "./widget-task.vue?vue&type=script&lang=js"
import style0 from "./widget-task.vue?vue&type=style&index=0&id=b9d4e058&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d4e058",
  null
  
)

export default component.exports